let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("frwee")).then(() => parcelRequire('bEyV4'));